export default __webpack_public_path__ + "static/media/implants_26@2x_red.6b31ae6b.png";